import { Box, Stack, Typography } from '@mui/material';
import type { HorizontalBarDatum } from '../types';

interface CategoryLegendProps {
  data: readonly HorizontalBarDatum[];
  colors?: readonly string[];
}

export const CategoryLegend = ({ data, colors }: CategoryLegendProps) => {
  if (!data.length) return null;
  return (
    <Stack
      direction='row'
      flexWrap='wrap'
      justifyContent='center'
      gap={1.5}
      sx={{ mt: 1, px: 1 }}
    >
      {data.map((datum, index) => {
        const color =
          datum.color ?? colors?.[index % (colors.length || 1)] ?? '#888';
        return (
          <Stack
            key={datum.id}
            direction='row'
            alignItems='center'
            spacing={0.75}
          >
            <Box
              sx={{
                width: 12,
                height: 12,
                borderRadius: '2px',
                backgroundColor: color,
                flexShrink: 0,
              }}
            />
            <Typography
              variant='caption'
              sx={{ fontSize: 12, lineHeight: 1.2 }}
            >
              {datum.name}
            </Typography>
          </Stack>
        );
      })}
    </Stack>
  );
};
